'use client';

import { FormattedMessage, useIntl } from 'react-intl';
import Image from '@alltrails/core/components/Image';
import Typography from '@alltrails/core/components/Typography';
import Button from '@alltrails/denali/components/Button';
import Heading from '@alltrails/denali/components/Heading';
import useIsMobileSizedScreen from '@alltrails/denali/hooks/useIsMobileSizedScreen';
import gearMobileSrc from './gear-mobile.avif';
import gearDesktopSrc from './gear.avif';
import styles from './styles.module.scss';

// Design: https://www.figma.com/design/6VHX3c5WyrLT83mIUBJiLU/2026-Homepage-update--Copy-?node-id=686-11728

const GearShop = () => {
  const isMobile = useIsMobileSizedScreen();
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <div className={styles.imageWrapper}>
        <Image
          src={isMobile ? gearMobileSrc : gearDesktopSrc}
          alt={intl.formatMessage({
            defaultMessage: 'An assortment of AllTrails hiking gear and outdoor accessories arranged on a green background.'
          })}
          sizes="100vw"
          className={styles.image}
        />
        <div className={styles.contentWrapper}>
          <div className={styles.content}>
            <Heading size={isMobile ? '400' : '500'} as="h2" className={styles.title}>
              <FormattedMessage defaultMessage="Gear up and get out there" />
            </Heading>
            <Typography variant={isMobile ? 'paragraph100' : 'paragraph200'} className={styles.description} component="p">
              <FormattedMessage defaultMessage="See what’s new this season" />
            </Typography>
            <Button
              text={<FormattedMessage defaultMessage="Shop AllTrails Gear" />}
              linkInfo={{ href: 'https://shop.alltrails.com' }}
              variant="accent"
              size={isMobile ? 'sm' : 'md'}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GearShop;
